import styled, { css } from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

interface IProps {
  error: boolean;
  notError: boolean;
  height?: number;
  width?: number;
  focus: boolean;
}

interface IContainerProps {
  marginBottom?: string;
  marginTop?: string;
}

export const Container = styled.div<IContainerProps>`
  margin-bottom: ${(props) => props.marginBottom || "22px"};
  margin-top: ${(props) => props.marginTop || "0px"};
`;

export const ContainerTitleWithBadge = styled.div`
  display: flex;
  align-items: center;
  height: 17px;
`;

export const Label = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  height: 17px;
  color: #666;
  margin-bottom: 8px;
`;

export const ContainerInput = styled.div<IProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.width ? props.width + "px" : "calc(100% - 20px)")};
  height: 48px;
  border: 2px solid
    ${(props) =>
      props.error && !props.notError
        ? stylesGlobalDefault.inputsBorderFocusError
        : props.focus
          ? stylesGlobalDefault.blue
          : stylesGlobalDefault.inputsBorderFocusOff};
  border-radius: 4px;
`;

export const InputText = styled.input`
  width: 100%;
  padding: 5px 10px;
  height: 37px;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export const ContainerIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding-right: 17px;
  padding-left: 17px;
`;

export const ErrorText = styled.span`
  color: ${stylesGlobalDefault.inputsBorderFocusError};
  font-size: 12px;
  margin-top: 5px;
  text-align: left;
  display: block;

  @media (max-width: 1600px) {
    margin-top: 1px;
  }
`;
